import { API_URL, BASE_URL } from "../utils/AppApiUrl";
import { post, userOnBoardPost } from "../utils/httpClient-methods";
import tokenHttpClient from "../utils/httpClient";

export const ValidateEmailWhileLoginService = async (email) => {
  try {
    const param = {
      username: email,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.validateEmail}`,
      param
    );

    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export const LoginService = async (data, captValue) => {
  try {
    const requestBody = {
      username: data?.username,
      password: data?.password,
      captchaValue: captValue,
      forcedLogin: data?.forcedLogin,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.signIn}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export const LogoutService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.logout}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("Error", err);
    throw err;
  }
};

export const GenerateTokenService = async (data) => {
  try {
    const requestBody = {
      username: data?.username,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.generateTokenForForgotPassword}`,
      requestBody
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export const GenerateTokenNonRilService = async (data) => {
  try {
    const requestBody = {
      username: data?.username,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.generateTokenInsideAppForgotPass}`,
      requestBody
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export const GenerateTokenUserOnBoard = async (data) => {
  try {
    const requestBody = {
      username: data?.username,
    };
    const response = await userOnBoardPost(
      tokenHttpClient,
      `${BASE_URL}${API_URL.generateTokenForUserOnboard}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};

export const ForgotPasswordService = async (data) => {
  try {
    const requestBody = {
      password: data?.password,
      tempPassword: data?.tempPassword,
      currentUserId: data?.currentUserId,
      username: localStorage.getItem("email"),
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.forgotPassword}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};
export const SendOtpService = async (data,randomToken, captValue) => {
  try {
    const requestBody = {
      username: data,
      randomToken: randomToken
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.sendOtp}`,
      requestBody
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};
export const VerifyOtpAPI = async (data) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.verifyOtp}`,
      data
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};
export const ResendOtpService = async (data) => {
  try {
    console.log({ data });
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.resendOTP}`,
      data
    );
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    console.log("error", err);
    throw err;
  }
};
